import { T } from '../../../../utils/I18n/I18n'
import React, {useEffect} from 'react';
import { useMutation } from '@apollo/client';
import { Link } from "react-router-dom";
import { useUserContext } from '../../../../context/UserContext';
import useResponsive from '../../../../hooks/useResponsive';
import { GET_USER_DATA } from '../../../../screens/PersonalAreaScreen/queriesPersonalArea';
import Button from '../../../UI/Button/Button';
import { DELETE_ADDRESS } from '../queriesAddress';
import AddressPresentation from './AddressPresentation';
import DesktopAddressesList from './DesktopAddressesList';
import MobileAddressesList from './MobileAddressesList';

const ShowAddress = ({ setEditedAddress, setAddAddress }) => {
    const { isMobile } = useResponsive();
    const { user: { addresses } } = useUserContext();

    const [deleteCustomerAddress] = useMutation(DELETE_ADDRESS, {
        refetchQueries: [{ query: GET_USER_DATA }],
    });

    const shippingAddress = addresses.filter(address => address.default_shipping === true)[0];
    const billingAddress = addresses.filter(address => address.default_billing === true)[0];
    const additionalAddresses = addresses.filter(address => !address.default_billing && !address.default_shipping);

    const setEditAddressId = id => setEditedAddress(addresses.find(address => address.id === id));
    const removeAddress = id => deleteCustomerAddress(id);

    return (
        <div className="address-wrapper">
            <span className="personal-area-title"><T id="address.addresses" /></span>
            <p className="profile-header"><T id="address.addedAddresses" /></p>
            <div className="addresses">
                {billingAddress ? (
                    <AddressPresentation address={billingAddress} setEditAddressId={setEditAddressId} addressType="naplatu" />
                ) : (
                    <div className="addresses__no-address">
                        <h4><T id="address.billingAddress" /></h4>
                        <p className="address__no-info"><T id="address.noInfo" /></p>
                    </div>
                )}

                {shippingAddress ? (
                    <AddressPresentation address={shippingAddress} setEditAddressId={setEditAddressId} />
                ) : (
                    <div className="addresses__no-address">
                        <h4><T id="address.shippingAddress" /></h4>
                        <p className="address__no-info"><T id="address.noShippingInfo" /></p>
                    </div>
                )}
            </div>
            <p className="profile-header"><T id="address.allAddresses" /></p>
            {additionalAddresses &&
                additionalAddresses.length > 0 &&
                (isMobile ? (
                    <MobileAddressesList
                        addresses={additionalAddresses}
                        setEditAddressId={setEditAddressId}
                        removeAddress={removeAddress}
                    />
                ) : (
                    <DesktopAddressesList
                        addresses={additionalAddresses}
                        setEditAddressId={setEditAddressId}
                        removeAddress={removeAddress}
                    />
                ))}
            <div className="address-button">
                <Button type="submit" trait="profile-hover" text={<T id="address.addAddress" />} onClick={() => setAddAddress(true)} />
            </div>
            <Link className="profile-form__link" to="/customer/account/">
                {<T id="edit.back" />}
            </Link>
        </div>
    );
};

export default ShowAddress;
